export default __webpack_public_path__ + "static/media/DebbieMooers.71a43740.jpg";